
<div *ngFor="let message of contextualMessagesDisplay" >

    <div *ngIf="message && message.isVisible" 
        class="sx-system-message__item sxl-flex"
        [ngClass]="{
        'sx-system-message--blue': message.severity===1 , 
        'sx-system-message--yellow': message.severity===2, 
        'sx-system-message--red': message.severity===3 || message.severity===4
        }">


    <div *ngIf="message.icon" class="sx-system-message__icon-container sxl-flex">
        <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
            <span class="sx-system-message__icon">
                <svg>
                    <use [xlink:href]="message.icon" [attr.href]="message.icon"/>
                </svg>
            </span>
        </div>
    </div>
    <div class="sx-system-message__body sxl-flex sxl-flex-1 sxl-items-center" 
        [ngClass]="{
            'sx-system-message__body--no-icon': !message.icon}">
        <div *ngIf="message" class="sx-system-message__message" [innerHtml]="message.content | safeHtml"></div>
        <div *ngIf="!message" class="sx-system-message__message">
            <ng-content></ng-content>
        </div>
    </div>
    </div>  
</div>